// Perakitan pesan WhatsApp ringkasan meeting dari skeleton `template` yang
// dikembalikan endpoint draft. Substitusi di sini harus literal & identik dengan
// backend supaya pratinjau == pesan yang benar-benar terkirim.

/** Jumlah slot poin di template ({{3}}..{{10}}). Server menolak 400 kalau lebih. */
export const WA_MAX_POINTS = 8;

/** Batas panjang pesan WhatsApp; lewat dari ini server balas 422 too_long. */
export const WA_MESSAGE_MAX_LENGTH = 1024;

/** Isi slot poin yang dikosongkan — nilai padding yang sama dipakai backend. */
export const WA_EMPTY_SLOT = "-";

/** Sapaan terpanjang ("Siang"/"Malam"). Lihat measureMessageLength. */
const GREETING_MAX_LENGTH = 5;

export const resolveMessageParams = ({ greeting, contactName, company }) => {
  const name = contactName || "Pelanggan";
  return {
    name,
    company: company || contactName || WA_EMPTY_SLOT,
    salutation: [greeting, name].filter(Boolean).join(" "),
    greetingLength: (greeting || "").length,
  };
};

/**
 * Belah template pada tiap {{n}}. Token dibiarkan utuh sebagai segmen supaya
 * pemanggil bisa menyisipkan field editable di slot poin.
 */
export const buildSegments = (template) => {
  const segments = [];
  const re = /\{\{(\d+)\}\}/g;
  let last = 0;
  let match;
  while ((match = re.exec(template)) !== null) {
    if (match.index > last) {
      segments.push({ type: "text", value: template.slice(last, match.index) });
    }
    segments.push({ type: "token", slot: Number(match[1]) });
    last = re.lastIndex;
  }
  if (last < template.length) {
    segments.push({ type: "text", value: template.slice(last) });
  }
  return segments;
};

/** {{1}} sapaan+nama, {{2}} perusahaan, {{3}}..{{10}} poin, {{11}} nama. */
export const resolveTokenText = (slot, params, points) => {
  if (slot === 1) return params.salutation;
  if (slot === 2) return params.company;
  if (slot === 11) return params.name;
  if (slot >= 3 && slot <= 10) {
    return (points[slot - 3] || "").trim() || WA_EMPTY_SLOT;
  }
  return "";
};

export const renderMessage = (template, params, points) =>
  buildSegments(template)
    .map((seg) =>
      seg.type === "token"
        ? resolveTokenText(seg.slot, params, points)
        : seg.value
    )
    .join("");

/**
 * Panjang pesan untuk cek batas 1024. Sapaan dihitung ulang backend saat kirim,
 * jadi dipakai sapaan terpanjang: tanpa ini pesan yang pas di batas saat draft
 * dibuat pagi ("Pagi") bisa ditolak 422 too_long begitu dikirim siang ("Siang").
 */
export const measureMessageLength = (template, params, points) =>
  renderMessage(template, params, points).length +
  Math.max(0, GREETING_MAX_LENGTH - params.greetingLength);
